import { Order } from '../../types/order/Order';
import { ConnectedStore } from '../../types/ConnectedStore';

export interface ExportColumn {
    key: string;
    label: string;
    tableHeader?: string;
    accessor: (order: Order, stores: ConnectedStore[]) => string;
}

const formatDateCET = (date: Date | undefined | null): string => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleString('sv-SE', {
        timeZone: 'Europe/Stockholm',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};

const formatDateOnlyCET = (date: Date | undefined | null): string => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleString('sv-SE', {
        timeZone: 'Europe/Stockholm',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

const formatNumber = (value: number | undefined | null): string => {
    if (value === undefined || value === null) return '';
    return value.toFixed(2).replace('.', ',');
};

const escapeSemicolon = (value: string): string => {
    if (!value) return '';
    return value.includes(';') ? `"${value.replace(/"/g, '""')}"` : value;
};

export const generateOrdersCsv = (
    orders: Order[],
    columns: ExportColumn[],
    stores: ConnectedStore[]
): string => {
    const header = columns.map(c => escapeSemicolon(c.label)).join(';');
    const rows = orders.map(order =>
        columns.map(c => escapeSemicolon(c.accessor(order, stores))).join(';')
    );
    return [header, ...rows].join('\n');
};

export const downloadCsv = (csvContent: string, filename: string): void => {
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export { formatDateCET, formatDateOnlyCET, formatNumber };
